import { render } from "./UPLOADMORE.vue?vue&type=template&id=2f2882b0&scoped=true"
import script from "./UPLOADMORE.vue?vue&type=script&lang=js"
export * from "./UPLOADMORE.vue?vue&type=script&lang=js"

import "./UPLOADMORE.vue?vue&type=style&index=0&id=2f2882b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2882b0"]])

export default __exports__